import React, { useContext, useEffect, useState, useRef } from "react";
import { Dropdown, Nav, Badge, Alert } from "react-bootstrap";
import { ThemeContext } from "../../../context/ThemeContext";
import MapWithRadius from "./MapWithRadius";

import { Bar } from "react-chartjs-2";

import pattern1 from "../../../images/pattern/pattern1.png";
import pattern2 from "../../../images/pattern/pattern2.png";

import axios from 'axios';
import { baseURL } from "../../../baseURL";
import Cookies from 'js-cookie';

import LifetimeAlert from '../LifetimeAlert/LifetimeAlert';
import SubscribeAlert from './SubscribeAlert';
import RecentClosedPositions from './RecentClosedPositions';

import {SetBackgroundTheme} from "../../setBackgroundTheme";
import CheckAuth from "../CheckAuth";

const Dashboard = () => {
  const [search, setSearch] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [country, setCountry] = useState("");
  const [error, setError] = useState("");
  const [taskAdded, setTaskAdded] = useState(false);
  const [loading, setLoading] = useState(false);

  const [loadingCountries, setLoadingCountries] = useState(false);
  const [findedCountries, setFindedCountries] = useState([]);
  const [selectedCountryID, setSelectedCountryID] = useState(0);
  const [selectedCountryName, setSelectedCountryName] = useState("");

  const [loadingStates, setLoadingStates] = useState(false);
  const [findedStates, setFindedStates] = useState([]);
  const [selectedStateID, setSelectedStateID] = useState(0);
  const [selectedStateName, setSelectedStateName] = useState("");

  const [loadingCities, setLoadingCities] = useState(false);
  const [findedCities, setFindedCities] = useState([]);
  const [selectedCityID, setSelectedCityID] = useState(0);
  const [selectedCityName, setSelectedCityName] = useState("");

  const [searchTypeRadius, setSearchTypeRadius] = useState(false);
  const [searchTypeCity, setSearchTypeCity] = useState(true);
  const [radiusKm, setRadiusKm] = useState(20);

  const [selectedCityLat, setSelectedCityLat] = useState(20);
  const [selectedCityLong, setSelectedCityLong] = useState(20);

  function selectSearchType(selected_type) {
    if(selected_type == 'city') {
      setSearchTypeCity(true);
      setSearchTypeRadius(false);
    } else {
      setSearchTypeCity(false);
      setSearchTypeRadius(true);
    }
  }
  

  
  
  
  

  const { changeBackground } = useContext(ThemeContext);
  useEffect(() => {
    SetBackgroundTheme(changeBackground, Cookies);
    // eslint-disable-next-line
  }, []);

  async function runNewTask() {
    setLoading(true);
    const data = {
      token: Cookies.get('token'),
      search: search,
      city: selectedCityName,
      state: selectedStateName,
      country: selectedCountryName,
      city_id: selectedCityID,
      state_id: selectedStateID,
      country_id: selectedCountryID,
      search_type_city: searchTypeCity,
      radius: radiusKm
    }

    try {
      const response = await axios.post(baseURL+'/api/dashboard/create_task', data);
      console.log("Main Statistic: ", response.data)
      if(response.data.status === 'ok') {
        setTaskAdded(true);
        await delay(5000);
        setTaskAdded(false);
      } else {
        setError(response.data.text);
      }
    } catch(err) {
      await delay(2000);
      await runNewTask();
    }
    setLoading(false);
  }

  const delay = ms => new Promise(
    resolve => setTimeout(resolve, ms)
  );

  useEffect(() => {
    // Ничего не отправляем на первом пустом рендере
    if (!country) return;

    setLoadingCountries(true);

    // ставим таймер
    const timerId = setTimeout(() => {
      findCountryList();
    }, 2000);

    // если country изменился раньше 2 с — обнуляем таймер
    return () => clearTimeout(timerId);
  }, [country]); // запускать эффект только когда меняется country

  async function findCountryList() {
    setLoadingCountries(true);
    const data = {
      token: Cookies.get('token'),
      search: country
    }

    try {
      const response = await axios.post(baseURL+'/api/location/find_country', data);
      console.log("Main Statistic: ", response.data)
      if(response.data.status === 'ok') {
        setFindedCountries(response.data.result)
      } else {
        setError(response.data.text);
      }
    } catch(err) {
      await delay(2000);
      await findCountryList();
    }
    setLoadingCountries(false);
  }

  useEffect(() => {
    if (!state) return;          // не ищем на пустой строке

    setLoadingStates(true);

    const timerId = setTimeout(() => {
      findStateList();
    }, 2000);                         // 2 с задержка

    return () => clearTimeout(timerId);
  }, [state]);                   // ← сработает, когда меняется state

  async function findStateList() {
    setLoadingStates(true);

    const data = {
      token: Cookies.get("token"),
      country_id: selectedCountryID,
      search: state
    };

    try {
      const response = await axios.post(baseURL+'/api/location/find_state', data);
      console.log("findStateList: ", response.data)

      if (response.data.status === "ok") {
        setFindedStates(response.data.result);
      } else {
        setError(response.data.text);
      }
    } catch (err) {
      // повторы, если нужно
      await delay(2000);
      await findStateList();
    }

    setLoadingStates(false);
  }

  // useEffect с debounce
  useEffect(() => {
    if (!city) return; // не искать, если поле пустое

    setLoadingCities(true);

    const timerId = setTimeout(() => {
      findCityList();
    }, 2000); // 2 секунды ожидания

    return () => clearTimeout(timerId);
  }, [city]); // зависимость от ввода города

  // функция поиска городов
  async function findCityList() {
    setLoadingCities(true);

    const data = {
      token: Cookies.get("token"),
      country_id: selectedCountryID,
      state_id: selectedStateID,
      search: city
    };

    try {
      const response = await axios.post(baseURL + "/api/location/find_city", data);
      console.log("findCityList: ", response.data);

      if (response.data.status === "ok") {
        setFindedCities(response.data.result);
      } else {
        setError(response.data.text);
      }
    } catch (err) {
      await delay(2000);
      await findCityList(); // повторный запрос при ошибке
    }

    setLoadingCities(false);
  }

  return (
    <div className="row">
      <CheckAuth />
      <div className="col-12">
        <div className="card">
          <div className="card-header">
            <h4 className="card-title">Run New Task</h4>
          </div>
          <div className="card-body">
            <div className="basic-form">
              <form onSubmit={(e) => e.preventDefault()}>

                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">Keyword Search Request</label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="E.g., “Builders”, “Real Estate Agents”, “Marketing Agencies”"
                      value={search}
                      onChange={(e) => {setSearch(e.target.value); setError("")} }
                    />
                  </div>
                </div>

                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">Country</label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Country"
                      value={selectedCountryName}
                      onChange={(e) => {setCountry(e.target.value); setSelectedCountryName(e.target.value); setSelectedCountryID(0); setSelectedStateID(0); setSelectedCityID(0); setSelectedStateName(""); setSelectedCityName(""); setError("")}}
                    />
                  </div>
                </div>

                {loadingCountries === true && (
                  <div className="form-group row">
                    <label className="col-sm-3 col-form-label"></label>
                    <div className="col-sm-9 text-xs">
                      <Badge variant="info light">Loading...</Badge>
                    </div>
                  </div>
                )}

                {loadingCountries === false && findedCountries.length > 0 && (
                  <div className="form-group row">
                    <label className="col-sm-3 col-form-label"></label>
                    <div className="col-sm-9">
                      <ul>
                        {findedCountries.map((item, i) => (
                          <li className="mt-1 mb-1 text-blue underline cursor-pointer" onClick={() => {setSelectedCountryID(item.id); setSelectedCountryName(item.name); setFindedCountries([]);  }}>{item.name}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                )}

                
                {selectedCountryID > 0 && (
                  <>
                    <div className="form-group row">
                      <label className="col-sm-3 col-form-label">State</label>
                      <div className="col-sm-9">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="State"
                          value={selectedStateName}
                          onChange={(e) => {setState(e.target.value); setSelectedStateName(e.target.value); setSelectedStateID(0); setSelectedCityID(0); setSelectedCityName(""); setError("")} }
                        />
                      </div>
                    </div>

                    {loadingStates=== true && (
                      <div className="form-group row">
                        <label className="col-sm-3 col-form-label"></label>
                        <div className="col-sm-9 text-xs">
                          <Badge variant="info light">Loading...</Badge>
                        </div>
                      </div>
                    )}

                    {loadingStates === false && findedStates.length > 0 && (
                      <div className="form-group row">
                        <label className="col-sm-3 col-form-label"></label>
                        <div className="col-sm-9">
                          <ul>
                            {findedStates.map((item, i) => (
                              <li className="mt-1 mb-1 text-blue underline cursor-pointer" onClick={() => {setSelectedStateID(item.id); setSelectedStateName(item.name); setFindedStates([]);  }}>{item.name}</li>
                            ))}
                          </ul>
                        </div>
                      </div>
                    )}
                  </>
                )}

                {selectedStateID > 0 && selectedCountryID > 0 && (
                  <>
                    <div className="form-group row">
                      <label className="col-sm-3 col-form-label">City</label>
                      <div className="col-sm-9">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="City"
                          value={selectedCityName}
                          onChange={(e) => {setCity(e.target.value); setSelectedCityName(e.target.value); setSelectedCityID(0); setError("")} }
                        />
                      </div>
                    </div>

                    {loadingCities=== true && (
                      <div className="form-group row">
                        <label className="col-sm-3 col-form-label"></label>
                        <div className="col-sm-9 text-xs">
                          <Badge variant="info light">Loading...</Badge>
                        </div>
                      </div>
                    )}

                    {loadingCities === false && findedCities.length > 0 && (
                      <div className="form-group row">
                        <label className="col-sm-3 col-form-label"></label>
                        <div className="col-sm-9">
                          <ul>
                            {findedCities.map((item, i) => (
                              <li className="mt-1 mb-1 text-blue underline cursor-pointer" onClick={() => {setSelectedCityID(item.id); setSelectedCityName(item.name); setFindedCities([]); setSelectedCityLat(item.latitude); setSelectedCityLong(item.longitude);  }}>{item.name}</li>
                            ))}
                          </ul>
                        </div>
                      </div>
                    )}

                    <div className="form-group row">
                      <label className="col-sm-3 col-form-label">Search type</label>
                      <div className="col-sm-9 d-flex align-items-center">
                        <div className="custom-control check-switch custom-checkbox mr-4">
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            id="customCheck1"
                            checked={searchTypeCity}
                            onChange={() => selectSearchType('city')}
                          />
                          <label className="custom-control-label" htmlFor="customCheck1">
                            <span className="d-block text-black font-w500">City</span>
                            <span className="fs-12">Only selected city</span>
                          </label>
                        </div>

                        <div className="custom-control check-switch custom-checkbox mr-4">
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            id="customCheck2"
                            checked={searchTypeRadius}
                            onChange={() => selectSearchType('country')}
                          />
                          <label className="custom-control-label" htmlFor="customCheck2">
                            <span className="d-block text-black font-w500">Radius</span>
                            <span className="fs-12">All cities around</span>
                          </label>
                        </div>
                      </div>
                    </div>

                    {searchTypeRadius == true && (
                      <>
                        <div className="form-group row">
                          <label className="col-sm-3 col-form-label">Radius, km</label>
                          <div className="col-sm-9">
                            <select className="form-control" value={radiusKm} onChange={(e) => setRadiusKm(parseInt(e.target.value))}>
                              <option value={20}>20 km</option>
                              <option value={40}>40 km</option>
                              <option value={60}>60 km</option>
                              <option value={80}>80 km</option>
                              <option value={100}>100 km</option>
                            </select>
                          </div>
                        </div>

                        <div className="form-group row">
                          <label className="col-sm-3 col-form-label"></label>
                          <div className="col-sm-9">
                            <MapWithRadius latitude={selectedCityLat} longitude={selectedCityLong} radiusKm={radiusKm} />
                          </div>
                        </div>
                      </>
                    )}
                  </>
                )}

                <div className="form-group row">
                  <label className="col-sm-3 col-form-label"></label>
                  <div className="col-sm-9">
                    <button className="btn btn-md btn-info" disabled={loading} onClick={() => runNewTask()}>
                      {loading === true && (
                        <span>Loading</span>
                      )}
                      {loading === false && (
                        <span>Run New Task</span>
                      )}
                    </button>

                    {taskAdded === true && (
                      <Alert variant="success" className="mt-3 alert-dismissible fade show">
                        The task has been added successfully. Open the "Download Leads" section to track the status.
                      </Alert>
                    )}
                    
                    {error !== "" && (
                      <Alert variant="danger" className="mt-3 alert-dismissible fade show">
                        {error}
                      </Alert>
                    )}

                  </div>
                </div>

              </form>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
};

export default Dashboard;
